import { render, staticRenderFns } from "./gridTension.vue?vue&type=template&id=1f1445e6&"
import script from "./gridTension.vue?vue&type=script&lang=js&"
export * from "./gridTension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports